import { guestRoutes } from './authGuard';

export const verfiedMobileGuard = (to, userStore) => {
  const { isAuthenticated, isMobileVerified } = userStore;

  const otpRoutes = ['otpVerification', 'mobile-registration'];

  if (
    isAuthenticated.value &&
    !isMobileVerified.value &&
    !['logout', ...otpRoutes].includes(to.name)
  ) {
    return { name: 'mobile-registration' };
  }

  if (
    isAuthenticated.value &&
    isMobileVerified.value &&
    (guestRoutes.includes(to.name) || otpRoutes.includes(to.name))
  ) {
    return { name: 'merchants' };
  }
};
